import { motion } from "framer-motion";
import { EASE, useSafeInView } from "@/components/Reveal";

export default function DriftDiagram() {
  const [ref, show] = useSafeInView();
  return (
    <div ref={ref}>
      <svg viewBox="0 0 420 320" className="h-auto w-full" data-testid="diagram-change-observability">
        {[60, 130, 200, 270].map((y, i) => (
          <line key={i} x1="30" y1={y} x2="400" y2={y} stroke="rgba(255,255,255,0.07)" strokeWidth="1" />
        ))}
        <motion.path
          d="M 30 130 C 90 126, 150 134, 210 130 C 260 127, 320 131, 400 129"
          fill="none"
          stroke="rgba(255,255,255,0.5)"
          strokeWidth="1.2"
          initial={{ pathLength: 0 }}
          animate={show ? { pathLength: 1 } : {}}
          transition={{ duration: 1.4, ease: EASE, delay: 0.2 }}
        />
        <motion.path
          d="M 30 132 C 90 130, 150 138, 210 150 C 260 165, 330 210, 400 250"
          fill="none"
          stroke="#00C0C8"
          strokeWidth="1.4"
          initial={{ pathLength: 0 }}
          animate={show ? { pathLength: 1 } : {}}
          transition={{ duration: 1.6, ease: EASE, delay: 0.5 }}
        />
        <motion.line
          x1="210" y1="40" x2="210" y2="290"
          stroke="rgba(255,255,255,0.18)"
          strokeDasharray="3 5"
          initial={{ opacity: 0 }}
          animate={show ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 1.3 }}
        />
        <motion.g
          initial={{ opacity: 0, y: 8 }}
          animate={show ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7, ease: EASE, delay: 1.5 }}
        >
          <circle cx="210" cy="150" r="5" fill="#00C0C8" />
          <circle cx="210" cy="150" r="12" fill="none" stroke="#00C0C8" strokeOpacity="0.4" className="animate-pulse-soft" />
          <text x="222" y="146" fill="rgba(255,255,255,0.6)" fontSize="10" fontFamily="'JetBrains Mono', monospace">
            drift detected
          </text>
        </motion.g>
        <motion.g
          initial={{ opacity: 0 }}
          animate={show ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 1.8 }}
        >
          <text x="30" y="112" fill="rgba(255,255,255,0.4)" fontSize="10" fontFamily="'JetBrains Mono', monospace">expected baseline</text>
          <text x="298" y="270" fill="rgba(0,192,200,0.9)" fontSize="10" fontFamily="'JetBrains Mono', monospace">observed behavior</text>
        </motion.g>
        {["Q1", "Q2", "Q3", "Q4"].map((q, i) => (
          <text key={q} x={44 + i * 115} y={308} fill="rgba(255,255,255,0.3)" fontSize="10" fontFamily="'JetBrains Mono', monospace">{q}</text>
        ))}
      </svg>
    </div>
  );
}
